import { TagProps } from '@hdi-seguros/web-components.card';

import { PolicyStates } from '../../interfaces';

export const getPolicyStatesTags = (states: Array<PolicyStates>): Array<TagProps> => {
    const tags: Array<TagProps> = [];

    states.forEach((state) => {
        if (state === PolicyStates.ACTIVE) {
            return tags.push({ label: 'Vigente', color: 'green' });
        };
        
        if (state === PolicyStates.INACTIVE) {
            return tags.push({ label: 'No vigente', color: 'orange' });
        };

        if (state === PolicyStates.CANCELED) {
            return tags.push({ label: 'Anulada', color: 'red' });
        };
        
        if (state === PolicyStates.SOON_TO_EXPIRE) {
            return tags.push({ label: 'Próxima a vencer', color: 'blue' });
        };

        if (state === PolicyStates.IS_RENEWAL) {
            return tags.push({ label: 'Renovación', color: 'cyan' });
        };
        if (state === PolicyStates.IS_WITHDRAWAL_REQUEST) {
            return tags.push({ label: 'Solicitud de arrepentimiento', color: 'grey' });
        };

        return state;
    });

    return tags;
};